import { cloneDeep } from 'lodash'
import { BoMItemRow, PartTypeRow } from 'model/Project/BoMItemRow'
import { MaterialSelectorUI } from '../../model/MaterialSelectorUI'
import { MaterialSummaryDto } from '../../services/APIs/InternalAPI/internal-api.contracts'
import { MaterialActionsConsts, MaterialActionsTypes } from './MaterialActions'

export type MaterialState = {
  readonly activeRows: PartTypeRow[]
  readonly materialSelectorUI: MaterialSelectorUI
  readonly isMaterialSelectorModalOpen: boolean
  materialSelectorClipboard: MaterialSummaryDto
  readonly wasChanged: boolean
  readonly currentElementId: string
  readonly isLoading: boolean
  remnantStrategyModal: {
    open: boolean
    materialId: string
    resourceId: string
    projectId: string
  }
}

const initialState: MaterialState = {
  activeRows: [],
  materialSelectorUI: undefined,
  materialSelectorClipboard: undefined,
  isMaterialSelectorModalOpen: false,
  wasChanged: false,
  currentElementId: undefined,
  isLoading: false,
  remnantStrategyModal: {
    open: false,
    materialId: '',
    resourceId: '',
    projectId: '',
  },
}

const MaterialReducer = (
  state = initialState,
  action: MaterialActionsTypes
): MaterialState => {
  switch (action.type) {
    case MaterialActionsConsts.OpenMaterialModal: {
      return {
        ...state,
        activeRows: action.activeRows,
        currentElementId: action.currentElementId,
        isLoading: true,
        isMaterialSelectorModalOpen: true,
      }
    }
    case MaterialActionsConsts.CloseWithoutSave: {
      return initialState
    }
    case MaterialActionsConsts.SetPossibleTokensAndMaterials: {
      const materialSelectorUI = new MaterialSelectorUI(
        action.tokensAndMaterials,
        action.selectedMaterial
      )

      return {
        ...state,
        materialSelectorUI: materialSelectorUI,
        isLoading: false,
      }
    }
    case MaterialActionsConsts.SetTokens: {
      // if (!action.selectedTokens) {
      //   return state
      // }

      const newMaterialSummary: MaterialSummaryDto = {
        tokens: action.selectedTokens,
      }

      const newRows = state.activeRows.map((x) => {
        return Object.assign({}, x, {
          materialSummary: newMaterialSummary,
        })
      })

      return {
        ...state,
        materialSelectorUI: {
          ...state.materialSelectorUI,
          selectedMaterial: newMaterialSummary,
          selectedTokens: Object.values(newMaterialSummary.tokens).flat(),
          selectableTokens: undefined,
        },
        activeRows: newRows,
      }
    }
    case MaterialActionsConsts.SetMaterial: {
      const newMaterialSummary = {
        ...action.material,
        ...{
          tokens: action.material.tokens,
        },
      }
      const newRows = state.activeRows.map((x) => {
        return {
          ...x,
          materialSummary: newMaterialSummary,
          // materialSummary: new MaterialSummaryDto(action.material),
        }
      })

      const newUI = Object.assign({}, state.materialSelectorUI, {
        selectedMaterial: newMaterialSummary,
        selectedTokens: Object.values(action.material.tokens).flat(),
      })

      return {
        ...state,
        materialSelectorUI: newUI,
        activeRows: newRows,
      }
    }
    case MaterialActionsConsts.SetIsLoading: {
      return {
        ...state,
        isLoading: action.isLoading,
      }
    }
    case MaterialActionsConsts.Set3dModelPath: {
      const newRow: BoMItemRow = Object.assign({}, state.activeRows[0], {
        threeDModelPath: action.threeDModelPath,
      })

      return {
        ...state,
        activeRows: [newRow],
      }
    }
    case MaterialActionsConsts.CopyMaterialToClipboard: {
      const materialSummaryWithoutDimensions = cloneDeep(action.materialSummary)

      delete materialSummaryWithoutDimensions.tokens['dimensions']
      delete materialSummaryWithoutDimensions.tokens['shape']
      materialSummaryWithoutDimensions.id = undefined
      materialSummaryWithoutDimensions.description = undefined

      return {
        ...state,
        materialSelectorClipboard: materialSummaryWithoutDimensions,
      }
    }

    case MaterialActionsConsts.OpenModalRemnantStrategy: {
      return {
        ...state,
        remnantStrategyModal: {
          open: true,
          materialId: action.materialId,
          resourceId: action.resourceId,
          projectId: action.projectId,
        },
      }
    }

    case MaterialActionsConsts.CloseModalRemnantStrategy: {
      return {
        ...state,
        remnantStrategyModal: {
          ...state.remnantStrategyModal,
          open: false,
        },
      }
    }
    default:
      return state
  }
}

export default MaterialReducer
